import React from "react";
import { cn } from "@/lib/utils";

function Button({
  className,
  children,
  onClick,
  type = "button",
  variant = "default",
  size = "default",
  disabled = false,
  ariaLabel,
  ...props
}) {
  const baseClasses = "inline-flex items-center justify-center rounded-soft border font-medium transition-all focus:outline-none focus:ring-2 focus:ring-offset-2";
  const variantClasses = {
    default: "bg-neutral-900 text-white border-neutral-900 hover:bg-neutral-800 focus:ring-neutral-500",
    outline: "bg-transparent border-neutral-300 hover:bg-neutral-50 focus:ring-neutral-500",
    ghost: "bg-transparent border-transparent hover:bg-neutral-100 focus:ring-neutral-500",
    pastel: "bg-rose-100 text-rose-900 border-rose-200 hover:bg-rose-200 focus:ring-rose-500",
    pastelOrange: "bg-orange-100 text-orange-900 border-orange-200 hover:bg-orange-200 focus:ring-orange-500",
  };
  const sizeClasses = {
    sm: "h-8 px-3 text-xs",
    default: "h-11 px-4 text-sm",
    lg: "h-12 px-6 text-base",
    icon: "h-10 w-10 p-0",
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      className={cn(baseClasses, variantClasses[variant], sizeClasses[size], disabled && "opacity-50 cursor-not-allowed", className)}
      {...props}
    >
      {children}
    </button>
  );
}

export { Button };
